export const environment = {
  production: true,
  wsUrl: 'wss://hal.st-apps.ztrac.com/ws/realtime',
  gtmId: 'GTM-ML5ZVJ6S'
};


